import React from "react";

function BS4_Jumbotron() {
  return (
    <div>
      <h1>BS4_Jumbotron Component</h1>
      <p>This is the BS4_Jumbotron tutorial page content.</p>
    </div>
  );
}

export default BS4_Jumbotron;
